/* istanbul ignore next */
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { isEmptyEvery } from 'common/utilities/utils';
import MenuSubCategoryItemList from '../Presentation/MenuSubCategoryItemList';
import NutritionAllergenItemList from '../Presentation/NutritionAllergenItemList';
import { isEmpty } from 'lodash';
import { DISPOSITIONNEW } from 'common/constants/SharedConstants';

import {
  BACK_TO_MENU,
  RETURNED_NO_RESULTS,
  YOUR_SEARCH_TEXT,
} from '../NutritionAllergenConstants/NutritionAllergenConstants';
import { ButtonComp } from 'atoms/Buttons';
import { Link } from 'react-scroll';

const hasSubcategory = (subcategory = []) => {
  return subcategory.length > 0;
};

const getMenusSubcategory = (category, handleSetActive, onItemClick) => {
  return (
    !isEmpty(category) &&
    category.map(({ id = '', isHidden = false, dname = '', url, categories: subcategory = [] }, index) => {
      return (
        /* istanbul ignore next */

        <ul className='inner-ul nested'>
          {!isHidden /* istanbul ignore next */ && (
            <li>
              <Link
                data-testid='subcategory-click-test'
                onClick={e => onItemClick(e, dname[0]?.value, url, index)}
                spy={true}
                to={id}
                className={`${hasSubcategory(subcategory) ? 'caret' : ''}`}
                onSetActive={handleSetActive /* istanbul ignore next */}
                smooth={true}
                activeClass={`${index === 0 ? 'active' : ''}`}
              >
                {dname[0]?.value}
              </Link>
              {subcategory && subcategory.length > 0 && getMenusSubcategory(subcategory)}
            </li>
          )}
        </ul>
      );
    })
  );
};

const getDispositionNewData = userOrderState => {
  return isEmptyEvery(userOrderState?.dispositionNew)
    ? JSON.parse(localStorage.getItem(DISPOSITIONNEW))
    : userOrderState?.dispositionNew;
};

/* show products for desktop and mobile view */
const renderItemList = (
  productsList,
  cardId,
  cType,
  tenantData,
  catalogs,
  storeClosedData,
  selectedCat,
  getCardCount,
  subCategories,
) => {
  return subCategories && subCategories.length ? (
    <>
      <MenuSubCategoryItemList
        subCategory={subCategories}
        cardType={cType}
        tenantData={tenantData}
        catalogs={catalogs}
        storeClosedData={storeClosedData}
      />
      <div className='hr-line'></div>
    </>
  ) : (
    <>
      <NutritionAllergenItemList
        productList={productsList}
        cardType={cType}
        tenantData={tenantData}
        categoryId={cardId}
        catalogs={catalogs}
        selectedCat={selectedCat}
        storeClosedData={storeClosedData}
        cardCount={getCardCount}
      />
      <div className='hr-line'></div>
    </>
  );
};

// menu search functionality result view

const renderMenuList = (
  recommendProducts,
  tenantData,
  catalogs,
  storeClosedData,
  getCardCount,
  cardType,
  categoryId,
) => {
  return (
    <NutritionAllergenItemList
      productList={recommendProducts}
      cardType={cardType}
      tenantData={tenantData}
      categoryId={categoryId}
      catalogs={catalogs}
      storeClosedData={storeClosedData}
      cardCount={getCardCount}
    />
  );
};

const searchModeElmnt = (searchMode, clearSearch, isMobileView = false) => {
  return (
    <>
      <div className={!isMobileView ? 'no-search-found-plp' : 'no-mob-search-found-plp'}>
        <span>{translateWithI18Next(YOUR_SEARCH_TEXT)}</span>
        <span className='no-search-found-text-highlighted'>{` “${searchMode.searchedData}” `}</span>
        <p>{translateWithI18Next(RETURNED_NO_RESULTS)}</p>
        <ButtonComp className='back-to-menu-plpsearch' data-testid='back-to-menu' onClick={clearSearch}>
          {translateWithI18Next(BACK_TO_MENU)}
        </ButtonComp>
      </div>
      <div className='horizontalLineBorder-noData'></div>
      <div className='horizontalLineBorder-noData-forMobile'></div>
    </>
  );
};

export { hasSubcategory, getMenusSubcategory, getDispositionNewData, renderItemList, searchModeElmnt };
